import { BlumCert } from "entities/cert";
import Profile from "shared/assets/svg/insta-profile.svg?react";
import { Button } from "shared/ui/button";

import successSvg from "../assets/success.svg";

type Props = {
  isLoading: boolean;
  onClaim: () => void;
};

const now = Date.now();

export const Success = ({ isLoading, onClaim }: Props) => {
  return (
    <>
      <img src={successSvg} className="h-[110px]" />
      <h2 className="mt-5 text-center text-[21px] font-semibold whitespace-pre-line">
        {`Success`}
      </h2>
      <p className="text-balticSea mt-2 text-lg leading-none">
        Your zkCertificate is ready!
      </p>

      <div className="mt-5 mb-5 w-full">
        <BlumCert expirationDate={now + 1000000} />
      </div>

      <Button
        isLoading={isLoading}
        onClick={onClaim}
        className="mt-auto w-full"
      >
        Claim Certificate <Profile className="ml-auto size-6" />{" "}
      </Button>
    </>
  );
};
